import Logo from '../Logo'
import styles from './Navigation.module.css'
import cx from 'classnames'
import React from 'react'

const BlankNavigation: React.FC = () => {
    return (
        <nav className={cx(styles['zr-nav'], styles['zr-sticky-nav'])}>
            <div className={cx(styles['zr-logo'])}>
                <Logo />
                <span>ZR Customizer</span>
            </div>
        </nav>
    )
}

export default BlankNavigation
